import * as React from "react";
function SvgTargetPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <circle cx={9.5} cy={9.5} r={3.5} />
      <path d="M11.61 17.72A8.2 8.2 0 019.5 18 8.5 8.5 0 1118 9.5a8.2 8.2 0 01-.28 2.11 4.61 4.61 0 01.87.63A9.23 9.23 0 0019 9.5 9.5 9.5 0 109.5 19a9.23 9.23 0 002.74-.41 4.61 4.61 0 01-.63-.87z" />
      <g strokeWidth={1.01} stroke="currentColor">
        <path d="M15.5 11v9M11 15.5h9" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTargetPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
